import { render, staticRenderFns } from "./safetyVideo.vue?vue&type=template&id=6db4b0d6&"
import script from "./safetyVideo.vue?vue&type=script&lang=js&"
export * from "./safetyVideo.vue?vue&type=script&lang=js&"
import style0 from "./safetyVideo.vue?vue&type=style&index=0&id=6db4b0d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports